import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import {Button} from '../Button';
import { upload, useAuth } from 'api';


const ANIM_DURATION = 300;

export default function MediaDialog(props) {
  
  const auth = useAuth();
  const companyId = auth ? auth.company.id : null;

  const {
    container = document.body,
    open = false,
    media = [],
    onSelect = () => null,
    onUpload,
    onRequestClose = () => null,
  } = props;
  
  
  
  // Handle File Uploading
  
  const fileInput = useRef();
  const [isUploading, setUploading] = useState(false);
  function handleUpload(e) {
    if(isUploading) {
      return;
    }
    fileInput.current.click();
  }
  
  async function handleFileChange(e) {
    setUploading(true);
    let file = e.target.files[0];
    const url = await upload(companyId, file);
    setUploading(false);
    onSelect(url);
  }
  
  
  
  // Render
  
  const modal = (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: open ? 1 : 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingTop: 0,
        paddingBottom: 0,
        cursor: "pointer",
        overflowY: 'auto',
        backgroundColor: 'rgba(0,0,0,0.25)',
        transition: `opacity ${ANIM_DURATION}ms ease-in-out`,
        zIndex: 1500,
        pointerEvents: open ? 'all' : 'none',
      }}>
      
      <input type="file" onChange={handleFileChange} style={{display:'none'}} ref={fileInput}/>
      
      <div 
        style={{
          position: 'relative',
          width: '80%',
          maxWidth: 800,
          minHeight: 80,
          transform: open ? 'translateY(0)' : 'translateY(100%)',
          cursor: 'default',
          overflow: 'hidden',
          flex: "0 0 auto",
          margin: 'auto',
          backgroundColor: 'white',
          boxShadow: '0 4px 8px 4gba(0,0,0,0.6)',
          transition: `transform ${ANIM_DURATION}ms ease-in-out`,
          borderRadius: 8,
        }} 
        onClick={e=>e.stopPropagation()}>
        
        <div style={{height:400, overflow:'auto', borderBottom:'1px solid #aaa', padding:16, marginBottom:16}}>
          {(media || []).map(item => {
            if(!item.url) {
              return null;
            }
            return (
              <img 
                key={item.url}
                src={item.url} 
                alt=""
                style={{
                  display: 'inline-block',
                  width: 80,
                  height: 80, 
                  margin: 8,
                  objectFit: 'contain',
                  cursor: 'pointer',
                  backgroundColor: "#eeeeee",
                  boxShadow: '0 2px 2px rgba(0,0,0,0.3)',
                }}
                onClick={() => onSelect(item.url)}
              />
            );
          })}
        </div>
        
        <div style={{display:'flex', alignItems:'center', justifyContent:'flex-end', marginBottom:16}}>
          <Button label="Cancel" onClick={onRequestClose}/>
          <Button label={isUploading ? "Uploading..." : "Upload Image"} onClick={onUpload ? onUpload : handleUpload}/>
        </div>
        
      </div>
    </div>
  );

  return ReactDOM.createPortal(modal, container);
}